import { Box } from '@mui/material'

import {
  FlexRowBetweenBox,
  SubheaderText,
  Text,
} from '@/components/IncomeCard/TrustedSources/styles'

export interface OptOutReasonValue {
  category: string
  additionalInformation?: string | null
}

interface Props {
  optOutReason: OptOutReasonValue
  getReasonText: (category: string) => string
  showAdditionalInformationOnlyFor?: string
}

const OptOutReasonSection: React.FC<Props> = ({
  optOutReason,
  getReasonText,
  showAdditionalInformationOnlyFor,
}) => {
  const showAdditionalInformation =
    !!optOutReason.additionalInformation &&
    (!showAdditionalInformationOnlyFor ||
      optOutReason.category === showAdditionalInformationOnlyFor)

  return (
    <FlexRowBetweenBox>
      <Box sx={{ flex: 1 }}>
        <SubheaderText variant="subtitle2">Selected reason</SubheaderText>
        <Text variant="body2">{getReasonText(optOutReason.category)}</Text>
      </Box>

      {showAdditionalInformation && (
        <Box sx={{ flex: 1 }}>
          <SubheaderText variant="subtitle2">Additional details</SubheaderText>
          <Text variant="body2">{optOutReason.additionalInformation}</Text>
        </Box>
      )}
    </FlexRowBetweenBox>
  )
}

export default OptOutReasonSection
